import { type QueryFunctionContext, useQuery } from '@tanstack/react-query';
import type { AxiosResponse } from 'axios';
import { endOfDay, getUnixTime, startOfDay, subDays } from 'date-fns';

import { apiClient } from '@services/apiClient';

import { DEFAULT_TIMESTAMPS_PERIOD } from '../constants/defaultTimestampsPeriod';

interface IResponse {
  data: { [key: string]: { [key: string]: { id: number } } };
}

export const fftTimestampsImpactKey = (pointId: number, axisId: number) => [
  'fftTimestampsImpact',
  +pointId,
  axisId,
];
export const fftTimestampsImpactFn = ({ queryKey }: QueryFunctionContext<(string | number)[]>) =>
  apiClient.get(`${APP_API_URL_V2}fsd/fft-timestamp/impact-vue`, {
    params: {
      installationPointId: queryKey[1],
      axisId: queryKey[2],
      from: getUnixTime(startOfDay(subDays(new Date(), DEFAULT_TIMESTAMPS_PERIOD))),
      to: getUnixTime(endOfDay(new Date())),
    },
  });

const fftTimestampsImpactSelect = ({ data }: AxiosResponse<IResponse>) => data?.data;

export const useFftTimestampsImpactQuery = ({ pointId, axisId }: { pointId?: number; axisId: number }) => {
  return useQuery({
    // @ts-ignore TODO: update react-query to v5
    queryKey: fftTimestampsImpactKey(pointId, axisId),
    queryFn: fftTimestampsImpactFn,
    enabled: !!pointId,
    select: fftTimestampsImpactSelect,
  });
};
